import React from 'react'

import styles from './Logo.module.css'

const Logo = () => <div className={styles.Logo}></div>

export default Logo
